<template>
    <RejectedPayments></RejectedPayments>
</template>
<script>
    import RejectedPayments from '@/components/EmployeeRejectedPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            RejectedPayments
        }
    }
</script>